import api from "@/services/api";
import { SessionInfoType } from "@/types/user/SessionInfo";

class GetSessionInfo {
  execute = async () => {
    const response = await api().get(`/session-info`);
    return response.data as SessionInfoType;
  };
}

export { GetSessionInfo };
